// extracted by mini-css-extract-plugin
module.exports = {"root":"post-grid_root__1LmPN","job":"post-grid_job__1PJ3u"};